import {
  pointLayer,
  unsafeMapId,
  unsafeMapLayerId,
} from "@cartographerio/atlas-map";
import {
  cartographerMapSourceWithDefaults,
  mapSchemaWithDefaults,
} from "../../core";
import {
  extendedRiverflyAttributeGroups,
  historyOptions,
  statusOptions,
} from "./helpers";

export const ExtendedRiverflyHistory = mapSchemaWithDefaults({
  mapId: unsafeMapId("extendedRiverflyHistory"),
  title: "Extended Riverfly Timeline",
  layers: [
    pointLayer({
      layerId: unsafeMapLayerId("extendedRiverflyHistory"),
      title: "Extended Riverfly Timeline",
      source: cartographerMapSourceWithDefaults({
        layerId: unsafeMapLayerId("extendedRiverflyHistory"),
        attribution: [],
      }),
      defaultAttribute: "trigger.score",
      attributes: extendedRiverflyAttributeGroups(historyOptions),
    }),
  ],
});

export const ExtendedRiverflyStatus = mapSchemaWithDefaults({
  mapId: unsafeMapId("extendedRiverflyStatus"),
  title: "Extended Riverfly Current Status",
  layers: [
    pointLayer({
      layerId: unsafeMapLayerId("extendedRiverflyStatus"),
      title: "Extended Riverfly Current Status",
      source: cartographerMapSourceWithDefaults({
        layerId: unsafeMapLayerId("extendedRiverflyStatus"),
        attribution: [],
      }),
      defaultAttribute: "trigger.breach",
      attributes: extendedRiverflyAttributeGroups(statusOptions),
    }),
  ],
});
